import * as React from 'react';
import { useLocation, useRouteMatch } from 'react-router';

import { EAppsCounters, EAppsGenreEng } from '@enums';

import { counters, translations } from '@utils';

import { Tabs } from '@base/components/ui';
import { getConfig, URLS } from '@base/constants';

import { ICatalogTabsProps, tabItemType } from './types';

import * as s from './CatalogTabs.scss';

export const CatalogTabs: React.FC<ICatalogTabsProps> = (props: ICatalogTabsProps) => {
	const [showCatalogTabs, setShowCatalogTabs] = React.useState(false);
	const catalogMainUrl = getConfig().apps.pathname || URLS.APPS;
	const tabs: tabItemType[] = [
		{
			title: translations.appCatalog('genre-all'),
			url: '',
			counter: EAppsCounters.MENU_GENRE_ALL,
		},
		{
			title: translations.appCatalog('strategy-games'),
			url: `/${EAppsGenreEng.STRATEGY}`,
			counter: EAppsCounters.MENU_STRATEGY,
		},
		{
			title: translations.appCatalog('lucky-games'),
			url: `/${EAppsGenreEng.LUCKY}`,
			counter: EAppsCounters.MENU_LUCKY,
		},
		{
			title: translations.appCatalog('role-play-games'),
			url: `/${EAppsGenreEng.ROLEPLAY}`,
			counter: EAppsCounters.MENU_ROLEPLAY,
		},
		{
			title: translations.appCatalog('casual-games'),
			url: `/${EAppsGenreEng.CASUAL}`,
			counter: EAppsCounters.MENU_CASUAL,
		},
		{
			title: translations.appCatalog('logic-games'),
			url: `/${EAppsGenreEng.LOGIC}`,
			counter: EAppsCounters.MENU_LOGIC,
		},
		{
			title: translations.appCatalog('games-3-in-row'),
			url: `/${EAppsGenreEng.ROWS}`,
			counter: EAppsCounters.MENU_ROWS,
		},
	];
	const { pathname } = useLocation();
	const getActiveTab = () => {
		const activeTab = tabs
			.findIndex((tab: tabItemType) => {
				if (!!tab.url) {
					return pathname.includes(tab.url);
				}
			});

		return activeTab > -1 ? activeTab : 0;
	};
	const [activeTab, setActiveTab] = React.useState(getActiveTab());
	const tabsItems = tabs.map((tab: tabItemType, i: number) => {
		const clickOnTab = function() {
			counters.sendRB(tab.counter);
		};

		return (
			<Tabs.Tab
				key={`tab_${tab.counter}`}
				className={s.tab}
				title={tab.title}
				url={`${catalogMainUrl}${tab.url}`}
				onClick={clickOnTab}
			/>);
	});
	const match: { params: { id: string } } = useRouteMatch([
		`${getConfig().apps?.pathname}/:id`,
		`${URLS.APPS}./:id`,
		`${getConfig().apps?.pathname}`,
		`${URLS.APPS}`,
	]);

	React.useEffect(() => {
		const activeTab = getActiveTab();
		const isCatalog = !!match;
		const params = match?.params;
		const isMainPage = isCatalog && !params?.id;
		const isParamsInTabsUrls = tabs[activeTab]?.url?.includes(match?.params?.id);
		const showTabs = isCatalog && (isMainPage || isParamsInTabsUrls);

		setActiveTab(activeTab);
		setShowCatalogTabs(showTabs);
	}, [pathname]);

	return (
		<>
			{showCatalogTabs && <Tabs
				className={s.block}
				classNameHead={s.tabs}
				activeTab={activeTab}
				shouldCenterActiveTab={true}
				hasCenterActiveTabAnimation={true}
				horizontalAnimationOffset={26}
				withContent={false}
			>
				{tabsItems}
			</Tabs>}
		</>
	);
};
